import { Token } from '@app/models/token';
import { httpClient, apiLinks } from '@app/utils';

const getUserInfoWithToken = async (): Promise<Token> => {
  const response = await httpClient.get({
    url: apiLinks.admin.userManagement.getUserProfile,
  });
  return response.data as Token;
};

const userService = {
  getUserInfoWithToken,
};

export default userService;
